export type Question = {
  id: string;
  item?: {
    id: string;
    type: string;
    linkId: string;
    required: boolean;
    enableWhen: EnableResource[];
  }[];
  text: string;
  type: string;
  linkId: string;
  required?: boolean;
  answerOption: AnswerOption[];
  enableBehavior?: any;
  enableWhen?: EnableResource[];
  prefix?: string;
  enables?: {
    question: string;
    withAnswer: string;
  }[];
  extension?: any;
};

type EnableResource = {
  answer: { string: string };
  operator: string;
  question: string;
};

export type AnswerOption = {
  id: string;
  value: {
    Reference?: { display: string };
    string: string;
  };
};

export type QuestionnaireEntity = {
  description: string;
  subjectType: string[];
  meta?: {
    lastUpdated: string;
    createdAt: string;
    versionId: string;
  };
  publisher: string;
  purpose: string;
  name: string;
  item: Question[];
  resourceType: string;
  title: string;
  status: string;
  id: string;
  originId: string;
  language?: string;
};

export const QUESTIONNAIRE_IDS = {
  health: "patient-health-screening-questionnaire",
  emotional: "patient-emotional-wellness-questionnaire",
  lifestyle: "patient-lifestyle-questionnaire",
  engagement: "patient-engagement-preferences-questionnaire",
  home: "patient-home-and-environment-questionnaire",
};
